export default __webpack_public_path__ + "static/media/aagaman.e956b69b.png";